import { FillTextOption } from '@tencent/alloy-editor';
import { ColorFill, FontStyle } from '@tencent/alloy-renderer';
import { convertColor } from '../utils/color';
import { filterOutIos15CrashFontFamily } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/font-utils';
import { RectText, RectTextOption } from '@tencent/docs-editor';
import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';

export function createTextNode(
    text: string,
    option: FillTextOption,
    textDirection: TextDirectionType,
    createRectText: (text: string, rectTextOption: RectTextOption) => RectText,
    isDeleteLineNotRotate?: boolean,
): RectText {
    const {
        x, y, width, height, fontSize, italic, boxX, boxY,
        fontFamily, fontWeight, strike, rotate, rotateOrigin,
        opacity, color, underline, drawLineOffsetX,
    } = option;
    const rectTextOption: RectTextOption = {
        textX: x, textY: y, rectX: boxX, rectY: boxY, rectWidth: width, drawLineOffsetX, isDeleteLineNotRotate,
        rectHeight: height, rotate, rotateOrigin, textDirection, underline, lineThrough: strike,
    };
    const textNode = createRectText(text, rectTextOption);
    if (typeof opacity === 'number') {
        textNode.alpha = opacity;
    }
    textNode.x = x;
    textNode.y = y ;
    textNode.fontSize = fontSize;
    textNode.fontWeight = fontWeight as any;
    textNode.fontFamily = filterOutIos15CrashFontFamily(fontFamily);
    if (italic) {
        textNode.fontStyle = FontStyle.Italic;
    }
    if (rotate && rotateOrigin) {
        // 这里逻辑有点绕
        textNode.x = textNode.x + rotateOrigin.x;
        textNode.y = textNode.y + rotateOrigin.y;
        textNode.pivotX = rotateOrigin.x;
        textNode.pivotY = rotateOrigin.y;
        textNode.angle = rotate;
    }
    textNode.fill = new ColorFill(convertColor(color));

    return textNode;
}
